import styled, { css, keyframes } from 'styled-components';
import { CONTAINER_PADDING } from '../const/sizes';
import { TITLE_SIZE_4, TITLE_SIZE_5 } from '../const/text';
import { DesignMenuIcon, LogosMenuIcon, NameMenuIcon } from '../const/icons';
import { device } from '../const/device';
import {
  SECONDARY_COLOR_2,
  SECONDARY_COLOR_5,
  SIDEBAR_ITEM_ICON_COLOR,
  SIDEBAR_ITEM_ICON_COLOR_ACTIVE,
  SIDEBAR_ITEM_ICON_COLOR_HOVER
} from '../const/color';

const IconList = {
  design: DesignMenuIcon,
  logos: LogosMenuIcon,
  name: NameMenuIcon,
};

const positions = [
  0,
  72,
  144
];

const mobilePositions = [
  0,
  48,
  96
];

const slide = (prev, next) => keyframes`
  0% {
    transform: translateY(${prev}px);
  }
  60% {
    //transform-origin: center;
    transform: scaleY(0.6) translateY(${next / 2}px);
  }
  100% {
    transform: translateY(${next}px);
  }
`;

export const ItemImage = styled.span<{ active: boolean, icon: string, themeColor: string }>`
  display: inline-block;
  width: 32px;
  height: 32px;
  margin-right: 12px;
  background-image: url("data:image/svg+xml,${props => IconList[props.icon](props.active ? SIDEBAR_ITEM_ICON_COLOR_ACTIVE : SIDEBAR_ITEM_ICON_COLOR)}");
  background-size: contain;
  
  @media (${device.tabletS}) {
    width: 22px;
    height: 22px;
    margin-right: 5px;
  }
`;

export const ItemText = styled.span<{ active: boolean, themeColor: string, only: boolean }>`
  font-family: "Fjalla One", serif;
  font-size: ${TITLE_SIZE_4}px;
  letter-spacing: 0.005em;
  text-transform: uppercase;
  color: ${props => props.themeColor == "black"?(props => props.active ? '#ffffff' : SECONDARY_COLOR_2):(props => props.active ? '#000000' : SECONDARY_COLOR_2)};
  
  @media (${device.tabletS}) {
    font-size: ${TITLE_SIZE_5}px;
    color: ${props => props.themeColor == "black"?(props => props.active && props.only ? '#ffffff' : '#000000'):(props => props.active ? '#000000' : SECONDARY_COLOR_2)};
    }
  }
`;

export const Item = styled.div<{ active: boolean, icon: string, themeColor: string }>`
  height: 32px;
  display: flex;
  align-items: center;
  cursor: ${props => props.active ? 'default' : 'pointer'};
  position: relative;
  
  &:not(:last-child) {
    margin-bottom: 40px;
    @media (${device.tabletS}) {
      margin-bottom: 25px;
    }  
  }
  
  &:hover ${ItemText} {
    color: ${props => props.themeColor == "black" ? '#ffffff' : SIDEBAR_ITEM_ICON_COLOR_HOVER};
  }

  ${props => !props.active ? css`
    &:hover ${ItemImage} {
      background-image: url("data:image/svg+xml,${props.themeColor == "black"?(IconList[props.icon](SECONDARY_COLOR_5)):(IconList[props.icon](SIDEBAR_ITEM_ICON_COLOR_HOVER))}");
    }
  ` : ''}
`;

export const ActiveLabel = styled.div<{ prevIndex?: number, index?: number }>`
    content: '';
    height: 32px;
    width: 4px;
    background-color: #10CBA5;
    position: absolute;
    left: -${CONTAINER_PADDING}px;
    top: 0;
    transition: transform 0.2s cubic-bezier(0.92,-0.02, 0.21, 0.82);
    transform: translateY(${props => positions[props.index]}px);
    // animation: 0.3s ${props => slide(positions[props.prevIndex], positions[props.index])} cubic-bezier(0.92,-0.02, 0.21, 0.82);
    //animation-fill-mode: forwards;
  
  @media (${device.tablet}) {
    display: none;
  }
  
  @media (${device.tabletS}) {
    display: block;
    height: 24px;
    left: -16px;
    transform: translateY(${props => mobilePositions[props.index]}px);
  }
`;

export const StateContainer = styled.div`
  position:absolute;
  z-index: 7;
  top: 12px;
  right: 70px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top:100px;
  flex: 0 0 128px;
  
  @media (${device.tablet}) {
    position: absolute;
    flex-direction: row;
    justify-content: space-between;
    z-index: 6;
    flex: none;
    top: 12px;
    width: 379px;
    left: 50%;
    margin-left: -${379 / 2}px;
    margin-top:0px;
  }
  
  
  
  @media (${device.tabletS}) {
    display:block;
    position: relative;
    margin: 0;
    flex-direction: column;
    top: auto;
    left: auto;
    width: auto;
    border-bottom: 1px solid ${SECONDARY_COLOR_5};
    > ${Item} {
      height: 24px;
    }
  }
`;
